import PropTypes from 'prop-types';
import {useRef} from 'react';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import useDidUpdateEffect from '../../../hooks/useDidUpdateEffect';
import isUsingArtemisStyles from '../../selectors/isUsingArtemisStyles';
import Spacing from '../../style-helper/Spacing';
import Typography from '../../style-helper/Typography';

const useStyles = createUseStyles({
  fieldHelpLabel: {
    marginTop: Spacing.single,
    fontSize: props => ((props.isUsingArtemisStyles && props.theme.typography?.[Typography.small]?.largeDevice)
      ? props.theme.typography[Typography.small].largeDevice.fontSize : props.theme.base.fontSize),
  },
});

export function FieldHelpLabel(props) {
  const helpLabelRef = useRef(null);
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  useDidUpdateEffect(() => {
    helpLabelRef.current.focus();
  }, [helpLabelRef.current]);
  
  return (
    <label ref={helpLabelRef} className={classes.fieldHelpLabel} data-test="FieldHelpLabel" id={`FieldHelpLabel--${props.id}`} htmlFor={props.id}>
      {props.children}
    </label>
  );
}

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

FieldHelpLabel.propTypes = {
  htmlFor: PropTypes.string,
  children: PropTypes.node.isRequired,
  isUsingArtemisStyles: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(FieldHelpLabel);
